import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseReleaseContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeApproved!: boolean;

  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;
}
